import { useCallback } from 'react';
import { CMS_WITH_NO_EMAIL_SIGNUP } from '../utils/constants';
import { useApplicationViewState } from './ApplicationViewStateContext';
import { useDomainSelection } from './DomainSelectionContext';
import { useMerchantSession } from './MerchantSessionContext';
import { useOwnershipClaim } from './OwnershipClaimContext';

/**
 * Custom hook that provides a complete logout function with all necessary cleanup.
 */
export const useCompleteLogout = () => {
  const { onLogout: baseLogout, merchantDetails } = useMerchantSession();
  const { setLicenseId, setCurrentAccessibeAccount } = useDomainSelection();
  const { resetOwnershipAccessToken } = useOwnershipClaim();
  const {
    authFlowNavigations: { goToDefaultAuthScreen },
    SignupWizard: { resetSignupWizard },
  } = useApplicationViewState();

  const completeLogout = useCallback(async () => {
    // Execute base logout (merchant session, user data, analytics)
    await baseLogout();

    // Clean up domain-specific data
    setLicenseId('');

    //clean up accessibe account data
    setCurrentAccessibeAccount(null);

    // Reset ownership claim data
    resetOwnershipAccessToken();
    // Reset signup wizard state
    resetSignupWizard();
    if (
      merchantDetails?.source &&
      !CMS_WITH_NO_EMAIL_SIGNUP.includes(merchantDetails?.source)
    ) {
      goToDefaultAuthScreen();
    }
  }, [
    baseLogout,
    setLicenseId,
    setCurrentAccessibeAccount,
    resetOwnershipAccessToken,
    resetSignupWizard,
    merchantDetails?.source,
    goToDefaultAuthScreen,
  ]);

  return { completeLogout };
};
